import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Article } from './shared/models/article.interface';
import { AuthService } from './shared/auth-service/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  title = 'BPS-DXF';

  constructor(private router: Router, private authService: AuthService) { }

  get loggedIn(): boolean {
    return !!this.authService.getToken();
  }

  logout(): void {
    this.authService.logout();
  }

  showNavigation(): boolean {
    return this.router.url !== '/login' && this.router.url !== '/' && this.router.url !== '/landing';
  }
}
